;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/blog/:slug*\",\"regex\":\"^/blog/(.+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/cards/:slug\",\"regex\":\"^/cards/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/subscribe\"},{\"path\":\"/about_us\"},{\"path\":\"/account\"},{\"path\":\"/account/settings\"},{\"path\":\"/ai-research\"},{\"path\":\"/articles\"},{\"path\":\"/auth/reset-password\"},{\"path\":\"/auth/signin\"},{\"path\":\"/auth/signup\"},{\"path\":\"/benchmarks\"},{\"path\":\"/blog\"},{\"path\":\"/blog/archive\"},{\"path\":\"/collection\"},{\"path\":\"/confirm\"},{\"path\":\"/contact\"},{\"path\":\"/explorer\"},{\"path\":\"/issues\"},{\"path\":\"/partnerships\"},{\"path\":\"/pricing\"},{\"path\":\"/privacy\"},{\"path\":\"/strategic-lab/blog/new\"},{\"path\":\"/strategic-lab/partners\"},{\"path\":\"/terms\"},{\"path\":\"/unsubscribe\"}],\"isrRoutes\":[\"/blog/:slug*\"]}";globalThis["_sentryNextJsVersion"] = "16.3.8";import './sentry.client.config';
import * as Sentry from '@sentry/nextjs';
import posthog from 'posthog-js';

const projectToken = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN;
const apiHost = process.env.NEXT_PUBLIC_POSTHOG_HOST;

if (projectToken && apiHost) {
  posthog.init(projectToken, {
    api_host: apiHost,
    defaults: '2026-01-30',
    capture_exceptions: true,
    debug: process.env.NODE_ENV === 'development',
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '.mask-text'
    }
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
